import React from 'react';
import {Link} from 'react-router';
import { Collapse } from "@blueprintjs/core";
import {ComposedChart, Line, Bar, XAxis, YAxis, CartesianGrid, Legend, Tooltip,  ResponsiveContainer } from 'recharts';

class MultipleChart extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isOpen: true
    }
  }

  handleCollapse() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
      <section className="wrap-collapse-100">
        <div className="wrap-shadow">
          <h2 className={this.state.isOpen ? "collapse-title collapse-open" : "collapse-title collapse-close"}><Link onClick={this.handleCollapse.bind(this)}>{this.props.title}</Link></h2>
          <Collapse isOpen={this.state.isOpen}>
            <ResponsiveContainer width="95%" height={400}>
              <ComposedChart data={this.props.data}>
                <XAxis dataKey="name"/>
                <YAxis allowDecimals={false} />
                <Legend/>
                <Tooltip/>
                <CartesianGrid strokeDasharray="3 3"/>
                <Bar dataKey='Khiếu nại' barSize={20} fill='#fd9c35'/>
                <Bar dataKey='Tố cáo' barSize={20} fill='#fec42c'/>
                <Bar dataKey='Kiến nghị, phản ánh' barSize={20} fill='#5578c2'/>
                <Bar dataKey='Tranh chấp đất' barSize={20} fill='#5793f3'/>
                <Line dataKey='Tổng số đơn' stroke='#1d89f2'/>
                <Line dataKey='Đơn trễ hạn xử lý' stroke='#e56900'/>
                <Line dataKey='Đơn trễ hạn giải quyết' stroke='#e50000'/>
             </ComposedChart>
            </ResponsiveContainer>
          </Collapse>
        </div>
      </section>
    );
  }
}

export default MultipleChart;



// WEBPACK FOOTER //
// ./src/components/modules/home/MultipleChart.jsx